<template>
	<div>
		<PageHeader
			:data="{
				name: 'Municipalities Import',
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Municipalities', to: '/municipalities' },
				],
			}"
		/>

		<div class="row">
			<div class="col-12">
				<div class="card mb-3">
					<div class="card-body">
						<h4 class="mb-2">Matching municipalities data</h4>
						<div class="row">
							<div class="col-6">
								<div class="form-group col-12 mb-3">
									<label for="file">Choose CSV file to import</label>
									<input class="form-control" type="file" @change="uploadCsvFile($event)" />
									<div v-if="loading">Uploading file</div>
								</div>
								Add fields that you wanna to update
								<button class="btn btn-primary btn-sm" @click="addFieldForUpdate()">Add field</button>
								<template v-for="(field, index) in fieldsToUpdate">
									<div :key="'f-' + index" class="form-group mt-3">
										<select class="form-select" v-model="field.column">
											<option value="">Select field</option>
											<template>
												<template v-for="(column, index) in tableColumns">
													<option :key="index" :value="column.name">{{ column.name }}</option>
												</template>
											</template>
										</select>
									</div>
								</template>
							</div>
							<div class="col-6"></div>
						</div>
					</div>
				</div>

				<div v-if="options.displayImport" class="card">
					<div class="card-body">
						<LPDataImporter :tableName="'municipalities'" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import LPDataImporter from '@/components/lp-data-importer/LPDataImporter'
import { handleErrors } from '../../actions/helpers'
import restApi from '../../api/index.js'
export default {
	name: 'MunicipalitiesImport',
	components: { PageHeader, LPDataImporter },
	data() {
		return {
			options: {
				displayImport: false,
			},
			tableColumns: [],
			csvColumns: [],
			path: '',
			fieldsToUpdate: [],
			model: 'municipality',
		}
	},
	computed: {
		...mapState(['authUser']),
	},
	created() {
		this.getTableColumns()
	},
	mounted() {},
	methods: {
		// Upload CSV file
		uploadCsvFile($event) {
			this.loading = true
			var form = new FormData()
			form.append('file', $event.target.files[0])
			form.append('name', this.tableName)

			const config = {
				headers: { 'content-type': 'multipart/form-data' },
			}
			restApi
				.post('/helper/upload-csv-file', form, config)
				.then(({ data }) => {
					this.csvColumns = data.headers
					this.path = data.path
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		// Get table Columns
		getTableColumns() {
			restApi
				.post('/helper/table-columns', { table: 'municipalities' })
				.then(({ data }) => {
					this.tableColumns = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		addFieldForUpdate() {
			let field = {
				column: '',
			}
			this.fieldsToUpdate.push(field)
		},
	},
}
</script>
